export default __webpack_public_path__ + "static/media/vire13.a6d4be0e.jpg";